import React from 'react';
import carrot from '../../assets/carrot-large.png';
import carrotTwo from '../../assets/ops_portal_logo.png';
import carrotThree from '../../assets/carrot3.png';
import PropTypes from 'prop-types';
import {faIcons} from "../../utils/iconConstants";

const LoadingSpinner = ({spinnerClassName = 'spinner-container-normal'}) => {
    const random = Math.floor(1000 * Math.random());
    return (
        <div data-testid={"spinner-container"} className={`spinner-container ${spinnerClassName}`}>
            {
                random === 0 ? <img alt={'carrot'} className={'spinner-carrot'}
                                    src={[carrot, carrotTwo, carrotThree][Math.floor(Math.random() * 3)]}/> :
                    <i data-testid={"carrot-spinner"} className={`${faIcons.carrot} fa-spin fa-500px spinner`}/>
            }
            Loading...
        </div>
    );
};

LoadingSpinner.propTypes = {
    spinnerClassName: PropTypes.string
}

export default LoadingSpinner;